/* ==========================================================================
   WarGrounds — avis produit : pastille, mention légale, masquage, mode invitation

   QUATRE RÔLES

   1. PASTILLE DE NOTE SOUS LE TITRE — le point CRO de ce fichier.
      Mesuré le 8 septembre à 400 px : le bloc d'avis se trouve à 4 055 px alors
      que le bouton d'ajout au panier est à 930 px. Un avis lu après la décision
      d'achat ne sert à rien. La pastille remonte la preuve sociale sous le titre
      et renvoie au bloc complet par l'ancre #avis.

      Judge.me rend TOUJOURS son balisage, même sans avis : il pose alors
      data-number-of-reviews="0". On ne peut donc pas se contenter de tester la
      présence d'un élément jdgm. Le lien est créé masqué et n'est révélé que si
      ce compteur dépasse zéro.

   2. Mention exigée par l'article L.111-7-2 sous le widget, avec lien vers la
      section 10 des CGU.

   3. Masquage du bloc tant qu'aucun avis n'existe : un zéro affiché est un signal
      négatif là où une absence ne dit rien.

   4. MODE INVITATION — exception au point 3.
      Quand on sollicite un client par message ou par e-mail, il faut qu'il
      atterrisse sur un bloc visible. Si l'adresse porte l'ancre #avis ou le
      paramètre ?avis=1, le bloc reste affiché même vide et la page y défile.
      Le lien à envoyer prend donc la forme :
        wargrounds-shop.com/products/fallen-empire-40?avis=1

      À noter : tant qu'aucun avis n'existe, Judge.me n'injecte rien dans le
      conteneur — pas même son bouton d'écriture. Le mode invitation ne prend
      donc tout son sens qu'une fois le premier avis en ligne, par l'import ou
      par la première demande automatique.

   v1.10.1 : quand la section affiche tous les avis de la boutique
   (data-wg-avis-liste), la mention est déjà rendue côté serveur et le widget
   Judge.me masqué ne sert qu'au formulaire : rien à masquer ni à poser.

   Pour tout annuler : retirer la ligne de chargement dans wg-mobile-cro.liquid.
   ========================================================================== */
(function () {
  'use strict';

  /* v1.9 : textes fournis par window.wgI18n (layout/theme.liquid, filtre t, 4 langues). */
  var I18N = window.wgI18n || {};
  var TXT = I18N.avis_mention || 'Avis d’acheteurs vérifiés uniquement. Modalités de collecte, de contrôle et de publication :';
  var LIEN = I18N.avis_link || 'voir nos CGU';
  var DELAI = 6000;

  var invitation = location.hash === '#avis'
    || /[?&]avis=1(&|$)/.test(location.search);

  /* ----------------------------------------------------------------------
     1. PASTILLE DE NOTE
     ---------------------------------------------------------------------- */
  function nombreAvis(racine) {
    var el = racine.querySelector('[data-number-of-reviews]');
    if (!el) return null;
    return parseInt(el.getAttribute('data-number-of-reviews'), 10) || 0;
  }

  function poserPastille() {
    var titre = document.querySelector('.wg-product__info h1');
    if (!titre || document.querySelector('[data-wg-rating]')) return;

    var conteneur = document.querySelector('#judgeme_product_reviews');
    var id = conteneur && conteneur.getAttribute('data-id');
    if (!id) return;

    var lien = document.createElement('a');
    lien.href = '#avis';
    lien.className = 'wg-rating-link';
    lien.setAttribute('data-wg-rating', '');
    lien.hidden = true;

    var badge = document.createElement('div');
    badge.className = 'jdgm-widget jdgm-preview-badge';
    badge.setAttribute('data-id', id);
    badge.setAttribute('data-template', 'index');
    lien.appendChild(badge);

    titre.insertAdjacentElement('afterend', lien);

    var debut = Date.now();
    var timer = setInterval(function () {
      var n = nombreAvis(badge);
      if (n !== null && n > 0) { lien.hidden = false; clearInterval(timer); return; }
      if (Date.now() - debut > DELAI) { clearInterval(timer); lien.remove(); }
    }, 400);
  }

  /* ----------------------------------------------------------------------
     2, 3 et 4. MENTION, MASQUAGE, INVITATION
     ---------------------------------------------------------------------- */
  function conteneurAvis() {
    return document.querySelector('#judgeme_product_reviews')
        || document.querySelector('.jdgm-rev-widg');
  }

  function contientDesAvis(c) {
    if (c.querySelector('.jdgm-rev')) return true;
    var w = c.querySelector('[data-number-of-reviews]');
    return !!w && (parseInt(w.getAttribute('data-number-of-reviews'), 10) || 0) > 0;
  }

  function masquerLeBloc(c) {
    var section = c.closest('.wg-avis') || c.closest('[id^="shopify-section"]');
    if (section) section.style.display = 'none';
  }

  function poserMention(c) {
    if (document.querySelector('[data-wg-avis-mention]')) return;

    var p = document.createElement('p');
    p.setAttribute('data-wg-avis-mention', '');
    p.style.cssText = 'margin:14px 0 0;font-size:12px;line-height:1.5;opacity:.6;';
    p.appendChild(document.createTextNode(TXT + ' '));

    var a = document.createElement('a');
    a.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'pages/cgu#avis';
    a.textContent = LIEN;
    a.style.textDecoration = 'underline';
    p.appendChild(a);

    c.appendChild(p);
  }

  function evaluer() {
    var c = conteneurAvis();
    if (!c || !contientDesAvis(c)) return false;
    poserMention(c);
    return true;
  }

  function demarrer() {
    poserPastille();
    if (document.querySelector('[data-wg-avis-liste]')) return;
    if (evaluer()) return;

    var obs = new MutationObserver(function () {
      if (evaluer()) obs.disconnect();
    });
    obs.observe(document.body, { childList: true, subtree: true });

    setTimeout(function () {
      obs.disconnect();
      var c = conteneurAvis();
      if (!c || contientDesAvis(c)) return;

      /* Sollicitation en cours : on laisse le bloc en place et on y amène. */
      if (invitation) {
        var ancre = document.getElementById('avis');
        if (ancre) ancre.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      masquerLeBloc(c);
    }, DELAI);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
